import * as helper from './../../../../../VX/View/Assets/Js/helper';
import * as Events from './Events';

export function initAnmeldung(element: HTMLDivElement) {
	const buttons = element.querySelectorAll('button');
	const btnMale = buttons.item(0);
	const btnFemale = buttons.item(1);
	const btnSubmit = buttons.item(2);
	const input = helper.$('#username');
	let gender = 'male';

	helper.addEventListener(btnMale, 'click', () => {
		helper.removeClass(btnFemale, 'selected');
		helper.addClass(btnMale, 'selected');
		gender = 'male';
	})
	helper.addEventListener(btnFemale, 'click', () => {
		helper.removeClass(btnMale, 'selected');
		helper.addClass(btnFemale, 'selected');
		gender = 'female';
	})

	helper.addEventListener(input, 'keydown', (e:KeyboardEvent) => {
		if (e.key === 'Enter') {
			sendname();
		}
	});

	function sendname() {
		const name = input.value;
		if (name.trim() === '') {
			helper.addClass(input, 'error');
			return;
		}

		helper.triggerEvent(window, Events.USERNAME_SELECTED, {name, gender});
		helper.fadeOut(element)
			.then(() => {
				helper.hide(element)
			});
	}

	helper.addEventListener(btnSubmit, 'click', () => {
		sendname();
	})
}
